export default "__VITE_ASSET__D0Zz_yVS__"